import styled from 'styled-components';

import Layout from '@/layout';

import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import StepsList from './components/StepsList';
import Advantages from './components/Advantages';
import Form from './components/Form';
import Map from './components/Map';
import WorkTypes from './components/WorkTypes';
import AdditionalList from './components/AdditionalList';
import MainGallery from './components/MainGallery';
import SecondaryGallery from './components/SecondaryGallery';

function RefitSingleLanding() {
  return (
    <Layout>
      <Component>
        <Hero />
        <AboutSection />
        <StepsList />
        <WorkTypes />
        <AdditionalList />
        <Advantages />
        <MainGallery />
        <SecondaryGallery />
        <Form />
        <Map />
      </Component>
    </Layout>
  );
}

export default RefitSingleLanding;

const Component = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
